<span class="text-transform-uppercase" translate>
	issue.cancel
</span>
<div class="snackbar-close-align-right">
	<button type="submit" mat-button class="button-link-margin" (click)="dismiss()">
		<span translate>issue.ok.value</span>
	</button>
</div>